import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {TeammateModel} from '../../../models/api/teammateModel';
import {TeammateAvatar} from '../../common/avatars/teammateAvatar';

/*
 * Props.
 */

export interface ComposerAvatarProps {
  author: TeammateModel;
}

/*
 * Constants.
 */

const avatarSize = VisualSizesEnum.LARGE;

/*
 * Style.
 */

const StyledAvatarDiv = styled.div`
  grid-area: avatar;
  margin: 16px 0 16px 16px;
`;

/*
 * Component.
 */

export const ComposerAvatar: FC<ComposerAvatarProps> = (props) => (
  <StyledAvatarDiv>
    <TeammateAvatar teammate={props.author} size={avatarSize} />
  </StyledAvatarDiv>
);
